import { BaseLoginProvider } from '@/helpers/entities/classes/providers/BaseLoginProvider';
export class FacebookBusinessLoginProvider extends BaseLoginProvider {
    constructor(clientId = process.env.VUE_APP_FB_APP_ID, locale = 'en_US', version = 'v13.0') {
        super();
        this.clientId = clientId;
        this.locale = locale;
        this.version = version;
    }
    initialize() {
        return new Promise((resolve) => {
            this.loadScript(FacebookBusinessLoginProvider.PROVIDER_ID, `//connect.facebook.net/${this.locale}/sdk.js`, () => {
                FB.init({
                    appId: this.clientId,
                    cookie: true,
                    xfbml: true,
                    version: this.version,
                });
                resolve();
            });
        });
    }
    signIn() {
        return new Promise((resolve) => {
            FB.login((response) => {
                resolve(response);
            }, {
                config_id: process.env.VUE_APP_FB_BUSINESS_CONFIG_ID || '1423119675014121',
                response_type: 'code',
                override_default_response_type: true,
            });
            if (process.env.NODE_ENV === 'development') {
                console.log('Error: The method FB.login can no longer be called from http pages.\nExists only in local environment since we are not using HTTPS.');
            }
        });
    }
}
FacebookBusinessLoginProvider.PROVIDER_ID = 'FACEBOOK';
